import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BathRoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getBathRoomByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<BathRoomModel>>(`${BASEURL}/bathRoom/getBathRoomById`, {
    params: {
      Id: id,
    },
  })
}
